export class CreatedResult {
  success: boolean;
  error: boolean;
  errorMessage: string;

  constructor(
    success: boolean = false,
    error: boolean = true,
    errorMessage: string = '') {
    this.success = success;
    this.error = error;
    this.errorMessage = errorMessage;
  }

}
